"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateForm = exports.WebformRenderer = void 0;
// Main component
var WebformRenderer_1 = require("./WebformRenderer");
Object.defineProperty(exports, "WebformRenderer", { enumerable: true, get: function () { return WebformRenderer_1.WebformRenderer; } });
// Validation
var validation_1 = require("./validation");
Object.defineProperty(exports, "validateForm", { enumerable: true, get: function () { return validation_1.validateForm; } });
